import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('btn') button: ElementRef<HTMLElement>;

  @Input() title: string = '';
  @Input() icon: string = '';
  @Output() onCLick: EventEmitter<void> = new EventEmitter();

  @HostBinding('class.trailIcon')
  @Input() trailIcon: boolean = false;
  @Input() style: ButtonStyle = ButtonStyle.DEFAULT;
  @HostBinding('attr.size')
  @Input() size: ButtonSize = ButtonSize.MEDIUM;

  @Input() disabled: boolean = false;

  @Input() hint: string = '';
  @Input() type?: string;
  @Input() default: boolean = false;

  get isOnlyIcon(): boolean {
    return this.icon.length && !this.title.length;
  }

  @HostBinding('class.flex-btn')
  get isStretch(): boolean {
    return this.style.match('stretch')?.index >= 0;
  }

  constructor(private hostElem: ElementRef) { 
  }
  
  public ngOnInit(): void {
    this.hostElem.nativeElement.addEventListener('click', this.clickControl.bind(this));
  }

  public ngAfterViewInit(): void {
    this.button.nativeElement.addEventListener('click', this.clickControl.bind(this));
    if (this.default) {
      this.button.nativeElement.setAttribute('default', '');
    }
  }

  public ngOnDestroy(): void {
    this.button.nativeElement.removeEventListener('click', this.clickControl.bind(this));
    this.hostElem.nativeElement.removeEventListener('click', this.clickControl.bind(this));
  }

  get buttonStyle(): string {
    if (!this.style?.length) {
      return 'link';
    }
    return this.isOnlyIcon ? 'round' : 'square'
  }

  private clickControl(event: Event): void {
    if (this.disabled) {
      event.preventDefault()
      event.stopPropagation();
    }
  }
}

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

export enum ButtonStyle {
  DEFAULT = '',
  OUTLINED = 'outlined',
  FILLED = 'filled',
  LINK = 'link'
}